module.exports = __webpack_public_path__ + "static/media/Casio-VZ-10M-Fretless-Bass-C2.8f9aca6c.wav";